import React, { useEffect, useState } from "react";
import "../../../App.css";
import { Layout } from "./layout";
import { DatePicker, Select, Table } from "antd";
import dayjs from "dayjs";
import { useGetInFlow, usePaymentSummary, useGetAvailableBalance } from "./Payments/hooks/usePayment";
import Moment from "moment";
import { array } from "yup";
import { FlapperSpinner } from "react-spinners-kit";
import { infoBlue, searchCollection, IconSMall } from "../../../core/assets/icons";
import {getAmountFilterOptions} from "../../services/utilityService";


const dateFormat = "YYYY/MM/DD";
const MdaViewStatement = () => {
  const [amountFilter, setAmountFilter] = useState<string>("");
  const [amountFilterOptions, setAmountFilterOptions] = useState<any[]>([]);

  const { isLoading, data: allPaymentSummary, mutate } = usePaymentSummary();

    const { data: availableData, mutate: mutateAvailableData, isLoading: isLoadingAvailableData } = useGetAvailableBalance()


  const dataSource: any[] = [];

  function getFormattedDate() {
    const weekdays = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const today = new Date();
    const dayOfWeek = weekdays[today.getDay()];
    const dayOfMonth = today.getDate();
    const month = months[today.getMonth()];
    const year = today.getFullYear();

    return `${dayOfWeek}, ${dayOfMonth} ${month} ${year}`;
  }

  function getAmountFilterOption() {
    // const amounts = allPaymentSummary?.map(obj => obj.amount);

    // console.log({amounts})
    // if (amounts?.length > 0 && amountFilterOptions.length === 0) {
    //   setAmountFilterOptions(getAmountFilterOptions(amounts, 5))
    // }
  }
  const lazydayUser = JSON.parse(
    localStorage.getItem("lazyday_user") as string
  );

  useEffect(() => {
    mutate();
    mutateAvailableData()
  }, []);

  useEffect(() => {
    getAmountFilterOption()
  }, [allPaymentSummary]);
  const columns = [
    {
      title: "S/N",
      dataIndex: "id",
      key: "id",
      width: "40",
    },
    {
      title: "Transaction Date",
      dataIndex: "dateAndTime",
      key: "dateAndTime",
      width: "77",
    },
    

    {
      title: "Reference Number",
      dataIndex: "paymentReference",
      key: "paymentReference",
      // width: '120'
    },
    
    {
      title: "Naration",
      dataIndex: "purpose",
      key: "purpose",
      // width: '130'
    },

        
 
    {
      title: "Inflow(CR)/Outflow(DR)",
      dataIndex: "amount",
      render: (_, record: any) => (
        <span className={`${record.incoming ? "text-success" : "text-danger"}`}>
          {record.incoming ? "+" : "-"}{" "}
          {record?.receiptsPayments?.toLocaleString()}
        </span>
      ),
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
      // width: '130'
    },
  ];

  //allPaymentSummary
  for (let i = 0; i <= allPaymentSummary?.length; i++) {
    // if (allPaymentSummary[i]) {
    //   const datad = {
    //     key: i.toString(),
    //     id: allPaymentSummary[i]?.id,
    //     dateAndTime: Moment(allPaymentSummary[i]?.dateTime).format(
    //       "MMMM Do YYYY, h:mm a"
    //     ),
    //     expenditureHeadSubhead: ``,
    //     service: allPaymentSummary[i]?.service,
    //     paymentReference: allPaymentSummary[i]?.paymentReference,
    //     fundingBank: allPaymentSummary[i]?.fundingBank,
    //     fundingAccount: allPaymentSummary[i]?.fundingAccount,
    //     receivingBank: allPaymentSummary[i]?.receivingBank,
    //     receivingAccount: allPaymentSummary[i]?.receivingAccount,
    //     currency: `NGN`,
    //     purpose: allPaymentSummary[i]?.purpose,
    //     receiptsPayments: allPaymentSummary[i]?.amount,
    //     balance: allPaymentSummary[i]?.balance,
    //     incoming: allPaymentSummary[i]?.incoming,
    //   };
    //   dataSource.push(datad);
    // }
  }

  // const handleMenuClick: MenuProps['onClick'] = (e: any) => {
  //     message.info('Click on menu item.', e.key);
  //     console.log('click', e);
  // };
  //
  // const menuProps2 = (
  //     <Menu onClick={handleMenuClick}>
  //         <Menu.Item key="Last 30 Days">Last 30 Days</Menu.Item>
  //         <Menu.Item key="Last 60 Days">Last 60 Days</Menu.Item>
  //         <Menu.Item key="Last 90 Days">Last 90 Days</Menu.Item>
  //     </Menu>
  // );

  const paymentReferenceList = Array.from(
    new Set(
      dataSource.map((obj) => {
        if (obj?.paymentReference === null) {
          return;
        }
        return obj.paymentReference;
      })
    )
  ).map((paymentReference) => ({
    value: paymentReference,
    label: paymentReference,
  }));

  const receivingBankList = Array.from(
    new Set(dataSource.map((obj) => obj.receivingBank))
  ).map((receivingBank) => ({
    value: receivingBank,
    label: receivingBank,
  }));

  const receivingAccountList = Array.from(
    new Set(dataSource.map((obj) => obj.receivingAccount))
  ).map((receivingAccount) => ({
    value: receivingAccount,
    label: receivingAccount,
  }));

  const serviceList = Array.from(
    new Set(
      dataSource.map((obj) => {
        if (obj?.service === null) {
          return;
        }
        return obj.service;
      })
    )
  ).map((service) => ({
    value: service,
    label: service,
  }));

  const fundingBankList = Array.from(
    new Set(
      dataSource.map((obj) => {
        if (obj?.fundingBank === null) {
          return;
        }
        return obj.fundingBank;
      })
    )
  ).map((fundingBank) => ({
    value: fundingBank,
    label: fundingBank,
  }));

  const fundingAccountList = Array.from(
    new Set(dataSource.map((obj) => obj.fundingAccount))
  ).map((fundingAccount) => ({
    value: fundingAccount,
    label: fundingAccount,
  }));

  const [account, setAccount] = useState<any>("");
  //setReference

  const [reference, setReference] = useState<any>("");
  const [amount, setAmount] = useState<any>("");
  const [fundingAcct, setFundingAccount] = useState<any>("");
  const [fundingBank, setFundingBank] = useState<any>("");
  const [serviceFilter, setServiceFilter] = useState<any>("");
  const [recivingBank, setRecivingBank] = useState<any>("");
  const [recivingAccount, setRecivingAccount] = useState<any>("");

  const fetchFilter = () => {
    let filter = `src-acct-num=${fundingAcct}&src-bank-code=${fundingBank}&dest-acct-num=${recivingAccount}&dest-bank-code=${recivingBank}&payment-ref=${reference}&service=${serviceFilter}&start-amount=${amountFilter.split('-')[0] || ''}&end-amount=${amountFilter.split('-')[1] || ''}`;
    //src-acct-num dest-acct-num service payment-ref amount mda-code mda-name
    // mutate(filter);

    mutate(filter, {
      onSuccess: (response: any) => {
        setReference("");
        setAmount("");
        setFundingAccount("");
        setFundingBank("");
        setServiceFilter("");
        setRecivingBank("");
        setRecivingAccount("");
      },
      //
    });
  };

  return (
    <>
      <>
        {isLoading ? (
          <div className="loading-container">
            <FlapperSpinner />
          </div>
        ) : (
          <div className={"mdaBalanceSheetPage"}>
            <div className={"mdaBalanceSheetRow1"}>
              <div className={"mdaBalSheetBreadcrumb"}>
 <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3151_44660)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M18 11.8125H9.63312L13.4763 7.96937L12.5 7L7 12.5L12.5 18L13.4694 17.0306L9.63312 13.1875H18V11.8125Z" fill="#6366F1"/>
</g>
<rect x="0.5" y="1" width="23" height="23" rx="11.5" stroke="#6366F1"/>
<defs>
<clipPath id="clip0_3151_44660">
<rect y="0.5" width="24" height="24" rx="12" fill="white"/>
</clipPath>
</defs>
</svg>



                <div>Net Cash</div>
              </div>

              <div>
                <Select
                  defaultValue="Last 30 Days"
                  style={{ width: 162 }}
                  options={[
                    { value: "last60Days", label: "Last 60 Days" },
                    { value: "last90Days", label: "Last 90 Days" },
                  ]}
                />

             
              </div>
            </div>

          

              <div className={"mdaBalanceSheetRowView3"}>
                   <div>
                 <img
                    src={IconSMall}
                    alt="search"
                    className="icon-style"
                  />
                </div>
                
                   <div>
                <span>STATEMENT OF ACCOUNT</span>
                </div>
                
                    <div>
                <span>{lazydayUser?.registeredName}</span>
              </div>
             

              <div>
                <div>
                  <div>Report Date & Time</div>
                  <div>{getFormattedDate()}</div>
                </div>

                <div>
                  <div>Administrative Code</div>
                  <div>{lazydayUser?.mdaAdminCode}</div>
                </div>

                <div>
                  <div>MDA Email</div>
                  <div> {lazydayUser?.contact?.email} </div>
                </div>

                <div>
                  <div>MDA Phone number</div>
                  <div>{lazydayUser?.contact?.phoneNumber}</div>
                  </div>
                  
                   <div>
                  <div>MDA Phone number</div>
                  <div>{lazydayUser?.contact?.phoneNumber}</div>
                  </div>
                  
                   <div>
                  <div>MDA Phone number</div>
                  <div>{lazydayUser?.contact?.phoneNumber}</div>
                </div>
              </div>
            </div>

            <div className={"mdaBalanceSheetRow4"}>
              <div>
                <div>Download report</div>
                <div>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#FBD0D1"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M10.254 16.156C10.362 16.004 10.51 15.878 10.698 15.778C10.89 15.674 11.108 15.622 11.352 15.622C11.636 15.622 11.892 15.692 12.12 15.832C12.352 15.972 12.534 16.172 12.666 16.432C12.802 16.688 12.87 16.986 12.87 17.326C12.87 17.666 12.802 17.968 12.666 18.232C12.534 18.492 12.352 18.694 12.12 18.838C11.892 18.982 11.636 19.054 11.352 19.054C11.108 19.054 10.892 19.004 10.704 18.904C10.52 18.804 10.37 18.678 10.254 18.526V20.584H9.414V15.676H10.254V16.156ZM12.012 17.326C12.012 17.126 11.97 16.954 11.886 16.81C11.806 16.662 11.698 16.55 11.562 16.474C11.43 16.398 11.286 16.36 11.13 16.36C10.978 16.36 10.834 16.4 10.698 16.48C10.566 16.556 10.458 16.668 10.374 16.816C10.294 16.964 10.254 17.138 10.254 17.338C10.254 17.538 10.294 17.712 10.374 17.86C10.458 18.008 10.566 18.122 10.698 18.202C10.834 18.278 10.978 18.316 11.13 18.316C11.286 18.316 11.43 18.276 11.562 18.196C11.698 18.116 11.806 18.002 11.886 17.854C11.97 17.706 12.012 17.53 12.012 17.326ZM13.2644 17.326C13.2644 16.99 13.3304 16.692 13.4624 16.432C13.5984 16.172 13.7824 15.972 14.0144 15.832C14.2464 15.692 14.5044 15.622 14.7884 15.622C15.0044 15.622 15.2104 15.67 15.4064 15.766C15.6024 15.858 15.7584 15.982 15.8744 16.138V14.56H16.7264V19H15.8744V18.508C15.7704 18.672 15.6244 18.804 15.4364 18.904C15.2484 19.004 15.0304 19.054 14.7824 19.054C14.5024 19.054 14.2464 18.982 14.0144 18.838C13.7824 18.694 13.5984 18.492 13.4624 18.232C13.3304 17.968 13.2644 17.666 13.2644 17.326ZM15.8804 17.338C15.8804 17.134 15.8404 16.96 15.7604 16.816C15.6804 16.668 15.5724 16.556 15.4364 16.48C15.3004 16.4 15.1544 16.36 14.9984 16.36C14.8424 16.36 14.6984 16.398 14.5664 16.474C14.4344 16.55 14.3264 16.662 14.2424 16.81C14.1624 16.954 14.1224 17.126 14.1224 17.326C14.1224 17.526 14.1624 17.702 14.2424 17.854C14.3264 18.002 14.4344 18.116 14.5664 18.196C14.7024 18.276 14.8464 18.316 14.9984 18.316C15.1544 18.316 15.3004 18.278 15.4364 18.202C15.5724 18.122 15.6804 18.01 15.7604 17.866C15.8404 17.718 15.8804 17.542 15.8804 17.338ZM19.0708 16.366H18.4888V19H17.6368V16.366H17.2588V15.676H17.6368V15.508C17.6368 15.1 17.7528 14.8 17.9848 14.608C18.2168 14.416 18.5668 14.326 19.0348 14.338V15.046C18.8308 15.042 18.6888 15.076 18.6088 15.148C18.5288 15.22 18.4888 15.35 18.4888 15.538V15.676H19.0708V16.366Z"
                      fill="#EE151D"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      fill="white"
                    />
                    <path
                      d="M17.8128 3.75H6.56245C6.31382 3.75001 6.07537 3.84878 5.89956 4.0246C5.72376 4.20041 5.62499 4.43887 5.625 4.6875V25.3125C5.62499 25.5611 5.72376 25.7996 5.89956 25.9754C6.07537 26.1512 6.31382 26.25 6.56245 26.25H23.4375C23.6862 26.25 23.9246 26.1512 24.1004 25.9754C24.2762 25.7996 24.375 25.5611 24.375 25.3125V10.3125M17.8128 3.75L24.375 10.3125M17.8128 3.75L17.8125 10.3125H24.375"
                      stroke="#A5CE9B"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="29"
                      height="29"
                      rx="1.5"
                      stroke="#E8E8E8"
                    />
                    <path
                      d="M12.504 17.266C12.504 17.386 12.496 17.494 12.48 17.59H10.05C10.07 17.83 10.154 18.018 10.302 18.154C10.45 18.29 10.632 18.358 10.848 18.358C11.16 18.358 11.382 18.224 11.514 17.956H12.42C12.324 18.276 12.14 18.54 11.868 18.748C11.596 18.952 11.262 19.054 10.866 19.054C10.546 19.054 10.258 18.984 10.002 18.844C9.75 18.7 9.552 18.498 9.408 18.238C9.268 17.978 9.198 17.678 9.198 17.338C9.198 16.994 9.268 16.692 9.408 16.432C9.548 16.172 9.744 15.972 9.996 15.832C10.248 15.692 10.538 15.622 10.866 15.622C11.182 15.622 11.464 15.69 11.712 15.826C11.964 15.962 12.158 16.156 12.294 16.408C12.434 16.656 12.504 16.942 12.504 17.266ZM11.634 17.026C11.63 16.81 11.552 16.638 11.4 16.51C11.248 16.378 11.062 16.312 10.842 16.312C10.634 16.312 10.458 16.376 10.314 16.504C10.174 16.628 10.088 16.802 10.056 17.026H11.634ZM14.9531 19L14.2691 17.968L13.6631 19H12.7631L13.8491 17.332L12.7511 15.676H13.6991L14.3771 16.702L14.9891 15.676H15.8891L14.7971 17.332L15.9011 19H14.9531ZM19.4474 17.266C19.4474 17.386 19.4394 17.494 19.4234 17.59H16.9934C17.0134 17.83 17.0974 18.018 17.2454 18.154C17.3934 18.29 17.5754 18.358 17.7914 18.358C18.1034 18.358 18.3254 18.224 18.4574 17.956H19.3634C19.2674 18.276 19.0834 18.54 18.8114 18.748C18.5394 18.952 18.2054 19.054 17.8094 19.054C17.4894 19.054 17.2014 18.984 16.9454 18.844C16.6934 18.7 16.4954 18.498 16.3514 18.238C16.2114 17.978 16.1414 17.678 16.1414 17.338C16.1414 16.994 16.2114 16.692 16.3514 16.432C16.4914 16.172 16.6874 15.972 16.9394 15.832C17.1914 15.692 17.4814 15.622 17.8094 15.622C18.1254 15.622 18.4074 15.69 18.6554 15.826C18.9074 15.962 19.1014 16.156 19.2374 16.408C19.3774 16.656 19.4474 16.942 19.4474 17.266ZM18.5774 17.026C18.5734 16.81 18.4954 16.638 18.3434 16.51C18.1914 16.378 18.0054 16.312 17.7854 16.312C17.5774 16.312 17.4014 16.376 17.2574 16.504C17.1174 16.628 17.0314 16.802 16.9994 17.026H18.5774Z"
                      fill="#6366F1"
                    />
                  </svg>
                </div>
              </div>

              <div>Filter by:</div>

              <div className={"mdaBalanceSheetSelectOptions"}>
                <Select
                  defaultValue="Payment Reference"
                  //style={{ minWidth: 162 }}
                  options={paymentReferenceList}
                  onChange={(e) => setReference(e)}
                />

                <Select
                  defaultValue="Amount Range"
                  //style={{ minWidth: 134 }}
                  options={[
                    { value: 10000, label: "100000 - 20000" },
                    { value: 30000, label: "300000 - 40000" },
                  ]}
                  onChange={(e) => setAmount(e)}
                />

                <Select
                  defaultValue="Receiving Bank"
                  //style={{ minWidth: 143 }}
                  options={receivingBankList}
                  onChange={(e) => setRecivingBank(e)}
                />

                <Select
                  defaultValue="Receiving Account"
                  //style={{ minWidth: 164 }}
                  options={receivingAccountList}
                  onChange={(e) => setRecivingAccount(e)}
                />

                <Select
                    defaultValue="Amount Range"
                    placeholder={'Filter by Amount'}
                    style={{ minWidth: 234 }}
                    onChange={(e) => setAmountFilter(e)}
                    options={[
                      { value: "", label: "Amount" },
                      ...amountFilterOptions
                    ]}
                    value={amountFilter}
                />

                <Select
                  defaultValue="Funding Bank"
                  //style={{ minWidth: 143 }}
                  options={fundingBankList}
                  onChange={(e) => setFundingBank(e)}
                />

                <Select
                  defaultValue="Funding Account"
                  //style={{ minWidth: 164 }}
                  options={fundingAccountList}
                  onChange={(e) => setFundingAccount(e)}
                />

                <Select
                  defaultValue="Service"
                  //style={{ minWidth: 88 }}
                  options={serviceList}
                  onChange={(e) => setServiceFilter(e)}
                />

                <Select
                  defaultValue="Currency"
                  //style={{ minWidth: 100 }}
                  options={[{ value: "NGN", label: "NGN" }]}
                  //onChange={(e) => setRecivingAccount(e)}
                />

                <button onClick={fetchFilter}>
                  <span>Apply Filter</span>
                  <svg
                    width="14"
                    height="13"
                    viewBox="0 0 14 13"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.63281 1H12.3723C12.4691 1 12.5639 1.02814 12.6451 1.08099C12.7263 1.13384 12.7903 1.20914 12.8295 1.29772C12.8687 1.38631 12.8813 1.48437 12.8658 1.57999C12.8503 1.6756 12.8074 1.76466 12.7422 1.83634L8.63257 6.35697C8.5489 6.449 8.50254 6.56892 8.50254 6.6933V10.2324C8.50254 10.3147 8.48221 10.3958 8.44337 10.4683C8.40453 10.5409 8.34838 10.6028 8.27989 10.6484L6.27989 11.9818C6.20459 12.032 6.11707 12.0608 6.02668 12.0652C5.93628 12.0695 5.8464 12.0493 5.76661 12.0066C5.68682 11.9639 5.62011 11.9003 5.57361 11.8227C5.5271 11.745 5.50254 11.6562 5.50254 11.5657V6.6933C5.50254 6.56892 5.45618 6.449 5.37251 6.35697L1.26284 1.83634C1.19768 1.76466 1.15475 1.6756 1.13925 1.57999C1.12376 1.48437 1.13637 1.38631 1.17556 1.29772C1.21474 1.20914 1.27882 1.13384 1.35999 1.08099C1.44117 1.02814 1.53595 1 1.63281 1Z"
                      stroke="#666666"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>

              <div style={{ overflowX: "auto" }}>
                <Table
                  dataSource={dataSource}
                  bordered
                  columns={columns}
                  scroll={{ x: "1950px" }}
                />
              </div>
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default MdaViewStatement;
